import React from 'react';
import PropTypes from 'prop-types';

import { Button, Modal, Header, Icon, Form, Message } from 'semantic-ui-react';

const AddPolicyModal = ({ open, onAdd, onCancel, onFieldChange, onHelp, policyNumber, loading, error, showSuccess, onSuccess, attempt }) => {
	let errorMessage,
		addButton,
		attemptLimitMessage,
		attemptLimitReached = false;

	if (attempt >= 3) {
		attemptLimitReached = true;
		attemptLimitMessage = <p>For help adding this policy, please contact Customer Service at 800.477.1660.</p>;
	}

	if (error) {
		const content = Array.isArray(error) ? error.map((e, index) => <div key={index}>{`${e}`}</div>) : error;
		errorMessage = (
			<Message error>
				<Message.Header>Add Policy Failed</Message.Header>
				<Message.Content>{content}</Message.Content>
				{attemptLimitMessage}
			</Message>
		);
	}

	if (!attemptLimitReached) {
		addButton = <Button id="addBtn" primary content='Add' onClick={onAdd} disabled={loading} />;
	}

	let dln, zip, dob;
	if (policyNumber) {
		if (policyNumber.toUpperCase().startsWith('PPA')) {
			dln = (
				<Form.Field>
					<input name='driversLicenseNumber' placeholder='Drivers License Number (no dashes) ' onChange={onFieldChange} disabled={attemptLimitReached} />
				</Form.Field>
			);
		}
		if (policyNumber.toUpperCase().startsWith('HOM') || policyNumber.toUpperCase().startsWith('PUP')) {
			dob = (
				<Form.Field>
					<input name='dateOfBirth' placeholder='Date of Birth (MM/DD/YYYY)' onChange={onFieldChange} disabled={attemptLimitReached} type="date" />
				</Form.Field>
			);
		}
		zip = (
			<Form.Field>
				<input name='zip' placeholder='Billing Zip Code (5 digits)' onChange={onFieldChange} disabled={attemptLimitReached} type="number" />
			</Form.Field>
		);
	}
	return (
		<Modal size='tiny' open={open} className='policy add'>
			<Header icon='add square' content='Add Policy' subheader='Fill in the fields below to verify your policy.' />
			{!showSuccess ? (
				<Modal.Content>
					<Form loading={loading} error>
						<Form.Field>
							<input name='policyNumber' placeholder='Policy Number' onChange={onFieldChange} disabled={attemptLimitReached} />
						</Form.Field>
						<Form.Field>
							<input name='policyHolder' placeholder='Policyholder' onChange={onFieldChange} disabled={attemptLimitReached} />
						</Form.Field>
						{dln}
						{dob}
						{zip}
						{errorMessage}
					</Form>
				</Modal.Content>
			) : (
				<Modal.Content className='success'>
					<Icon name='check circle' size='massive' color='green' />
					<Header as='h1' content='Policy Added Successfully!' />
				</Modal.Content>
			)}
			{!showSuccess ? (
				<Modal.Actions>
					<Button id="cancelBtn" content='Cancel' onClick={onCancel} disabled={loading} />
					{addButton}
				</Modal.Actions>
			) : (
				<Modal.Actions>
					<Button positive content='Continue' onClick={onSuccess} disabled={loading} />
				</Modal.Actions>
			)}
		</Modal>
	);
};

AddPolicyModal.propTypes = {
	open: PropTypes.bool.isRequired,
	onCancel: PropTypes.func.isRequired,
	onAdd: PropTypes.func.isRequired,
	onFieldChange: PropTypes.func.isRequired,
	policyNumber: PropTypes.string,
	loading: PropTypes.bool,
	showSuccess: PropTypes.bool,
	onSuccess: PropTypes.func.isRequired,
	error: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};

export default AddPolicyModal;
